import React, { memo, useMemo } from "react";
import "./OrderBook.css";

const areArraysEqual = (arr1, arr2) => {
  if (!arr1 || !arr2) return false;
  if (arr1.length !== arr2.length) return false;
  return arr1.every((item, i) => item[0] === arr2[i][0] && item[1] === arr2[i][1]);
};

const OrderBookRow = memo(
  ({ price, volume, total, totalUSDT, type }) => {
    return (
      <div className={`order-book-row ${type}`}>
        <span className="price">{parseFloat(price).toFixed(6)}</span>
        {/* <span className="volume">{parseFloat(volume).toFixed(2)}</span> */}
        {/* <span className="total">{parseFloat(total).toFixed(2)}</span> */}
        <span className="volume-usdt">{parseFloat(totalUSDT).toFixed(2)}</span>
      </div>
    );
  },
  (prev, next) =>
    prev.price === next.price &&
    prev.volume === next.volume &&
    prev.total === next.total &&
    prev.totalUSDT === next.totalUSDT &&
    prev.type === next.type
);
OrderBookRow.displayName = "OrderBookRow";

const OrderBook = memo(
  ({ asks = [], bids = [], symbol }) => {
    const processedData = useMemo(() => {
      const calc = (orders) => {
        let total = 0;
        let totalUSDT = 0;
        return orders.map(([priceStr, volStr]) => {
          const price = +priceStr;
          const volume = +volStr;
          total += volume;
          totalUSDT += price * volume;
          return {
            priceStr,
            volumeStr: volStr,
            price,
            volume,
            total,
            totalUSDT,
          };
        });
      };

      const processedAsks = calc(asks.slice(0, 5));
      const processedBids = calc(bids.slice(0, 5));

      const askPrice = asks.length ? +asks[0][0] : 0;
      const bidPrice = bids.length ? +bids[0][0] : 0;
      const spreadPercent =
        askPrice && bidPrice ? (((askPrice - bidPrice) / bidPrice) * 100).toFixed(4) : "0";

      return { processedAsks, processedBids, spreadPercent };
    }, [asks, bids]);

    const asksList = useMemo(
      () =>
        processedData.processedAsks.map((row) => (
          <OrderBookRow
            key={`ask-${symbol}-${row.price}`}    // 🔑 стабильный ключ по цене
            price={row.priceStr}
            volume={row.volumeStr}
            total={row.total}
            totalUSDT={row.totalUSDT}
            type="ask"
          />
        )),
      [processedData.processedAsks, symbol]
    );

    const bidsList = useMemo(
      () =>
        processedData.processedBids.map((row) => (
          <OrderBookRow
            key={`bid-${symbol}-${row.price}`}    // 🔑 стабильный ключ по цене
            price={row.priceStr}
            volume={row.volumeStr}
            total={row.total}
            totalUSDT={row.totalUSDT}
            type="bid"
          />
        )),
      [processedData.processedBids, symbol]
    );

    return (
      <div className="order-book">
        <div className="order-book-content">
          <div className="asks-section">
            <div className="order-book-row header">
              <span className="header-price">Цена</span>
              {/* <span className="header-volume">Объем</span> */}
              {/* <span className="header-total">Всего</span> */}
              <span className="header-usdt">USDT</span>
            </div>
            <div className="asks-list">
              {asksList.length ? asksList : <div className="no-data">Нет данных о продажах</div>}
            </div>
          </div>

          <div className="spread-section">
            <div className="spread-info">
              <span className="spread">Спред: {processedData.spreadPercent}%</span>
            </div>
          </div>

          <div className="bids-section">
            <div className="bids-list">
              {bidsList.length ? bidsList : <div className="no-data">Нет данных о покупках</div>}
            </div>
          </div>
        </div>
      </div>
    );
  },
  (prev, next) =>
    prev.symbol === next.symbol &&
    areArraysEqual(prev.asks, next.asks) &&
    areArraysEqual(prev.bids, next.bids)
);

OrderBook.displayName = "OrderBook";
export default OrderBook;
